import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import numeral from 'numeral';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actionCreators } from '../../state/cart-header-dux';
import { withRouter } from 'react-router';
import fetchDux from '../../state/fetch-dux';
import CookieLink from './CookieLink';

const REACT_APP_SILVEROAK_LINK = `${process.env.REACT_APP_SILVEROAK_LINK}`;

class CustomToggle extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }
  render() {
    return (
      <a
        href="#"
        className="shopping-bag"
        role="button"
        id="shoppingBag"
        onClick={this.handleClick}
      >
        Cart (<span className="shopping-bag-qty">{this.props.children}</span>)
      </a>
    );
  }
}

const getImageHref = (
  {
    imageHref
  }
) => `${imageHref}`;

const Item = (
  {
    productHref,
    brandingId,
    imageHref,
    unitPrice,
    kitMarkdown,
    qty,
    skuDescription,
    shoppingCartItemId,
    handleRemoveItem,
    clubContinuityTypeId
  }
) => {
  const onRemoveItem = e => {
    e.preventDefault();
    handleRemoveItem(shoppingCartItemId);
  };

  const imgSrc = getImageHref({ imageHref, clubContinuityTypeId });

  return (
    <div className="item">
      <div className="row">
        <div className="col-4">
          <img src={imgSrc} alt={skuDescription} />
        </div>
        <div className="col-8">
          <h3>
            {brandingId === 1 &&
              <CookieLink
                href={`${REACT_APP_SILVEROAK_LINK}${productHref}`}
                label={skuDescription}
              />}
            {brandingId === 2 && <Link to={productHref}>{skuDescription}</Link>}
          </h3>
          <p>
            Quantity: {qty}<br />
            {numeral(unitPrice-(kitMarkdown || 0)).format('$0,0.00')}
          </p>
          <a href="#" className="remove" onClick={onRemoveItem}> × Remove</a>
        </div>
      </div>
    </div>
  );
};

class HeaderCartDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = { show: false, itemAdded: null };
    this.timeout = null;
    this.clearHeaderState = this.clearHeaderState.bind(this);
  }

  componentDidUpdate() {
    const {
      show,
      itemAdded
    } = this.state;

    const { addedItem, cart } = this.props;

    if (!addedItem || (show && itemAdded)) return;

    clearTimeout(this.timeout);
    this.setState({ show: true, itemAdded: addedItem });
    this.timeout = setTimeout(this.clearHeaderState, 3000);
  }

  clearHeaderState() {
    clearTimeout(this.timeout);
    this.props.clearCartAdd();
    this.setState({ show: false, itemAdded: null });
  }

  render() {
    const { cart, history, deleteCartItem } = this.props;
    const { show, itemAdded } = this.state;
    const {
      shoppingCartItems,
      totals
    } = cart || {};

    const {
      totalAmountDue
    } = totals || {};

    const numItems = (shoppingCartItems || [])
      .reduce((prev, { qty }) => prev + qty, 0);

    const toggleShow = value => {
      if (!value) return this.clearHeaderState();
      this.setState({ show: true, itemAdded: null });
    };

    const navigate = url =>
      e => {
        e.preventDefault();
        this.clearHeaderState();
        history.push(url);
      };

    const handleRemoveItem = shoppingCartItemId =>
      deleteCartItem(shoppingCartItemId);

    const itemAddShow = (shoppingCartItems || [])
      .find(({ kitId }) => kitId === (itemAdded || {}).kitId);

    const noItems = (shoppingCartItems || []).length === 0;

    return (
      <Dropdown show={show}>
        {show && <div className="backdrop" onClick={() => toggleShow(false)} />}
        <Dropdown.Toggle as={CustomToggle} onClick={() => toggleShow(!show)}>
          {numItems}
        </Dropdown.Toggle>
        <Dropdown.Menu className="cart-dropdown-menu">
          <div className="dropdown-inner">
            <div className="cart-dropdown">

              <span className="added-to-cart" style={{ display: 'block' }}>
                <div className="row actions">
                  {itemAdded && <div className="col">✓ Added to cart</div>}
                  <div className="col text-right">
                    <a
                      href="#"
                      className="close-cart-drop"
                      aria-label="Close this window"
                      onClick={e => toggleShow(false)}
                    >
                      ×
                    </a>
                  </div>
                </div>
              </span>

              {itemAdded &&
                <Item
                  {...itemAddShow || {}}
                  handleRemoveItem={handleRemoveItem}
                />}

              {noItems &&
                <span id="cartDropdownItems">
                  <div className="empty-cart">
                    There are no items in your cart
                  </div>
                  {/*
                    <Link to="/ship/">See where we ship</Link>
                  */}
                </span>}

              {!itemAdded &&
                (shoppingCartItems || [])
                  .map((item, index) => (
                    <Item
                      key={index}
                      {...item}
                      handleRemoveItem={handleRemoveItem}
                    />
                  ))}

              <span className="your-cart">
                <table width="100%" className="total">
                  <tbody>
                    <tr>
                      <td>TOTAL:</td>
                      <td className="text-right">
                        {numeral(totalAmountDue).format('$0,0.00')} USD
                      </td>
                    </tr>
                  </tbody>
                </table>
                <a href="/shop/cart/" className="btn btn-primary btn-block">
                  Checkout
                </a>
              </span>

              <span className="added-to-cart">
                <p className="disclaimer">
                  Please make sure we ship to your state or country.
                  {/*
                    <Link to="/ship/">See where we ship</Link>
                  */}
                </p>
                <div className="form-row">
                  <div className="col">
                    <Link
                      to="/shop/cart"
                      onClick={navigate('/shop/cart')}
                      className="btn btn-inverse btn-block"
                    >
                      View Cart (
                      <span className="shopping-bag-qty">{numItems}</span>
                      )
                    </Link>
                  </div>
                  <div className="col">
                    <Link
                      to="/shop/cart/checkout"
                      onClick={navigate('/shop/cart/checkout')}
                      className="btn btn-primary btn-block"
                      disabled={noItems}
                    >
                      Checkout
                    </Link>
                  </div>
                </div>
              </span>

            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapState = state => {
  const {
    error,
    result: cart,
    inProgress
  } = state.getCart.toJS();

  const addedItem = state.cartHeader;

  return {
    cart,
    addedItem
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      deleteCartItem: fetchDux.deleteCartItem.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(withRouter(HeaderCartDropdown));
